export const styles = theme => ({
  card: {
    maxWidth: "480px",
    margin: "0 auto"
  },
  amount_row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    padding: "10px 0",
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
    "&:last-child": {
      borderBottom: "none"
    }
  },
  amount_currency: {
    fontSize: "13px",
    color: "rgba(0, 0, 0, 0.54)"
  },
  amount_value: {
    fontSize: "22px",
    fontWeight: "500"
  },
  approve_button: {
    backgroundColor: "#FFCA28",
    color: "#3D4051",
    "&:hover": {
      backgroundColor: "#FFB300"
    }
  },
  reject_button: {
    backgroundColor: "#FFCA28",
    color: "#3D4051",
    "&:hover": {
      backgroundColor: "#FFB300"
    }
  },
  result_icon: {
    fontSize: "72px"
  },
  wrong_account_icon: {
    fontSize: "64px",
    color: "#FFCA28"
  },
  wrong_account_title: {
    margin: "10px 0 0 0",
    color: "#3D4051"
  },
  wrong_account_text: {
    margin: "10px 0 0 0",
    color: "rgba(0, 0, 0, 0.64)",
    lineHeight: "1.6"
  },
  wrong_account_details: {
    margin: "20px 0",
    padding: "10px 0",
    borderTop: "1px solid rgba(0, 0, 0, 0.08)",
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
    textAlign: "left"
  },
  wrong_account_detail_row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    padding: "5px 0"
  },
  wrong_account_detail_label: {
    fontSize: "13px",
    color: "rgba(0, 0, 0, 0.54)",
    paddingRight: "10px",
    whiteSpace: "nowrap"
  },
  wrong_account_detail_value: {
    fontSize: "15px",
    fontWeight: "500",
    color: "#3D4051",
    wordBreak: "break-word",
    textAlign: "right"
  },
  wrong_account_current: {
    margin: "0 0 5px 0",
    fontSize: "13px",
    color: "rgba(0, 0, 0, 0.54)",
    wordBreak: "break-word"
  },
  wrong_account_button: {
    backgroundColor: "#FFCA28",
    color: "#3D4051",
    "&:hover": {
      backgroundColor: "#FFB300"
    }
  }
});
